/* eslint-disable */

import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import { Box, Flex, HStack, Text, useColorModeValue } from "@chakra-ui/react";
import { shallowEqual, useSelector } from "react-redux";

export function SidebarLinks(props: { routes: RoutesType[] }) {
  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("brand.500", "white");
  let textColor = useColorModeValue("secondaryGray.500", "white");
  let brandColor = useColorModeValue("brand.500", "brand.400");

  const { routes } = props;
  const { user }: IUser | any = useSelector((state: UserState) => state.user);

  const { carts }: readonly ICart[] | any = useSelector(
    (state: CartsState) => state.carts,
    shallowEqual
  );

  const { promo }: readonly ICart[] | any = useSelector(
    (state: PromoState) => state.promo,
    shallowEqual
  );

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName: string) => {
    return location.pathname.includes(routeName);
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes: RoutesType[]) => {
    return routes.map((route: RoutesType, index: number) => {
      if (
        (route.layout === "/site" ||
          route.layout === "/auth" ||
          route.layout === "/landing" ||
          route.layout === "/banda" ||
          route.layout === "/content" ||
          route.layout === "/sponsor" ||
          route.layout === "/rtl") &&
        route.path !== "/content" &&
        route.path !== "/reserve_order" &&
        route.path !== "/m_cont_edit" &&
        route.path !== "/cnt_owner_page" &&
        route.path !== "/e_gallery" &&
        route.path !== "/sponsor_gallery" &&
        // route.path !== "/my_adds" &&
        // route.path !== "/sponsor_gallery" &&
        route.path !== "/cart_review" &&
        route.path !== "/upload_promo" &&
        route.path !== "/upload_content" &&
        route.path !== "/landing" &&
        route.path !== "/events" &&
        route.path !== "/sign-up" &&
        route.path !== "/sign-in" &&
        route.path !== "/register_banda" &&
        route.path !== "/register_sponsor" &&
        route.path !== "/register_content" &&
        route.path !== "/register" &&
        route.path !== "/sponsor_profile" &&
        route.path !== "/profile_content" &&
        route.path !== "/sign_in_bandajamii" &&
        route.path !== "/banda_details" &&
        route.path !== "/promo-reserve" &&
        route.path !== "/content-view" &&
        route.path !== "/sponsor_details" &&
        route.path !== "/view-gallery"
      ) {
        return (
          <NavLink key={index} to={route.layout + route.path}>
            {route.icon ? (
              <Box>
                <HStack
                  // spacing={
                  //   activeRoute(route.path.toLowerCase()) ? "18px" : "20px"
                  // }
                  // py="2px"
                  ps="10px"
                  // bg={"red"}
                  // marginTop={"0px"}
                  marginBottom={"2px"}
                >
                  <Flex w="100%" alignItems="center" justifyContent="center">
                    <Box
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeIcon
                          : textColor
                      }
                      me="16px"
                    >
                      {route.path === "/saved_cart" &&
                        user.loginStatus &&
                        user.sponsorStatus === "sponsor" &&
                        !(user.mode === "banda") && (
                          <div
                            style={{
                              justifyContent: "center",
                            }}
                          >
                            {(carts.length > 0 || promo.length > 0) && (
                              <p
                                style={{
                                  padding: 2,
                                  fontSize: 8,
                                  backgroundColor: "green",
                                  // backgroundColor: "red",
                                  color: "white",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                  borderRadius: 15,
                                }}
                              >
                                {/* {carts.length + promo.length} */}
                              </p>
                            )}
                          </div>
                        )}
                      {route.path === "/cart_review" &&
                        user.loginStatus &&
                        user.sponsorStatus === "sponsor" &&
                        !(user.mode === "banda") && (
                          <div
                            style={{
                              justifyContent: "center",
                            }}
                          >
                            {[...carts, ...promo].filter((cart: any) => {
                              return cart.activeCart === true;
                            }).length > 0 && (
                              <div
                                style={{
                                  width: 7,
                                  height: 7,
                                  fontSize: 12,
                                  backgroundColor: "#29bf12",
                                  borderRadius: 10,
                                }}
                              />
                            )}
                          </div>
                        )}
                      {route.icon}
                    </Box>

                    <Text
                      me="auto"
                      fontSize={"small"}
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeColor
                          : textColor
                      }
                      fontWeight={
                        activeRoute(route.path.toLowerCase())
                          ? "bold"
                          : "normal"
                      }
                    >
                      {route.name}
                    </Text>
                  </Flex>
                  <Box
                    h="30px"
                    w="4px"
                    bg={
                      activeRoute(route.path.toLowerCase())
                        ? brandColor
                        : "transparent"
                    }
                    borderRadius="5px"
                  />
                </HStack>
              </Box>
            ) : (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                  }
                  py="5px"
                  ps="10px"
                >
                  <Text
                    me="auto"
                    color={
                      activeRoute(route.path.toLowerCase())
                        ? activeColor
                        : inactiveColor
                    }
                    fontWeight={
                      activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                    }
                  >
                    {route.name}
                  </Text>
                  <Box h="36px" w="4px" bg="brand.400" borderRadius="5px" />
                </HStack>
              </Box>
            )}
            {(route.path === "/upload_content" ||
              route.path === "upload_promo") &&
              false && (
                <div>
                  <Text
                    me="auto"
                    fontSize={"small"}
                    color={
                      activeRoute(route.path.toLowerCase())
                        ? activeColor
                        : textColor
                    }
                    fontWeight={
                      activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                    }
                  >
                    {route.name}
                  </Text>

                  <Text
                    me="auto"
                    fontSize={"small"}
                    color={
                      activeRoute(route.path.toLowerCase())
                        ? activeColor
                        : textColor
                    }
                    fontWeight={
                      activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                    }
                  >
                    {route.name}
                  </Text>
                </div>
              )}
          </NavLink>
        );
      }
    });
  };
  //  BRAND
  return <>{createLinks(routes)}</>;
}

export default SidebarLinks;
